export const constraint05x = '820w';
export const constraint1x = '1200w';
export const MOBILE_SIZE_EDGE = 812;
export const THEMES = {LIGHT: 'light', DARK: 'dark'};
